import { Environment as EnvironmentEnum } from '@gea/digital-ui-lib';
import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  endpoint: string;
}

//Environment Configurations are stored in the asset folder
export type EnvironmentConfiguration = {
  name: EnvironmentEnum | null;
  oAuth: {
    redirectURL: string;
    callbackRedirectURL: string;
    postLogoutRedirectURL: string;
    clientId: string;
    authorityDomain: string;
    authority: string;
  };
  devOpsOAuth: {
    redirectURL: string;
    postLogoutRedirectURL: string;
    clientId: string;
    authority: string;
  };
  baseURL: string;
  storageURL: string;
  localizationStorageURL: string;
  iconStorageURL: string;
  portal: {
    subscriptionKey?: string;
    baseURL?: string;
    redirectURL: string;
  };
  featureFlag: {
    baseURL?: string;
  };
  cookielawId?: string;
  production?: boolean;
  endpoint: string;
};

export const ENVIRONMENT_CONFIG = new InjectionToken<Environment>('Environment_Configuration');
